export enum HttpErrors {
    Default = 'There was an issue. Please try again later.',
    DefaultUpload = 'Could not upload file. Please try again later.'
}
